<mat-toolbar class="page__config-toolbar" *ngIf="!(isPreviewMode$ | async)">
  <div class="nav__container">
    <div class="nav__container__left-section">
      <button mat-button (click)="closeLayer() && drawer.toggle()">
        <mat-icon>menu</mat-icon><span class="nav__container__left-section-config">Page Configuration</span>
      </button>
      <button mat-button class="nav__container__left-section-config" (click)="onPreview()">Preview</button>
      <button mat-button class="nav__container__left-section-config" (click)="openConfiguration()">
        {{ translations.GLOBAL_CONFIG }} </button>
      <button mat-button class="nav__container__left-section-config" (click)="onDiscard()">Discard Changes</button>
    </div>
    <div class="nav__container__right-section">
      <div class="nav__template_font-section">
        <button mat-button (click)="themeDrawer.toggle()">{{translations.TEMPLATE_SETTINGS}}</button>
      </div>
      <button mat-button>{{userName?.firstName}} {{userName?.lastName}}</button>
      <button mat-button (click)="signout()">Sign Out</button>
    </div>
  </div>
</mat-toolbar>

<mat-drawer-container>
  <mat-drawer #drawer mode="side">
    <app-page-config-side-nav></app-page-config-side-nav>
  </mat-drawer>
  <mat-drawer #themeDrawer mode="side" position="end" class="theme-drawer">
    <div class="theme-drawer__header">
      <h2>{{translations.TEMPLATE_SETTINGS}}</h2>
      <button mat-icon-button (click)="themeDrawer.close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-form-field appearance="outline">
      <mat-label>{{translations.TEMPLATE}}</mat-label>
      <mat-select [(ngModel)]="selectedTemplate" (selectionChange)="onTemplateChange()">
        <mat-option *ngFor="let template of templateConfig" [value]="template.id">
          {{template.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="theme-drawer__custom-toggle">
      <span>{{translations.COLORS}}</span>
    </div>

    <div
      class="theme-drawer__custom-colors"
      [formGroup]="customColorsForm"
    >
      <div class="color-row" *ngFor="let key of customColorKeys">
        <span class="color-row__label">{{ customColorLabels[key] }}</span>
        <div class="color-row__control">
          <span class="color-row__value">
            {{ customColorsForm.controls[key].value }}
          </span>
          <ngx-colors ngx-colors-trigger [formControlName]="key"></ngx-colors>
        </div>
      </div>
    </div>

    <mat-form-field appearance="outline" class="theme-drawer__font-field">
      <mat-label>{{translations.FONT_FAMILY}}</mat-label>
      <mat-select [(ngModel)]="selectedFont" (selectionChange)="onFontChange()">
        <mat-option *ngFor="let font of fontFamilyConfig" [value]="font.value">
          {{font.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </mat-drawer>
  <ng-container *ngTemplateOutlet="routerOutlet"></ng-container>
</mat-drawer-container>

<ng-template #routerOutlet>
  <div>
    <router-outlet></router-outlet>
  </div>
</ng-template>